(() => {
  if (customElements.get('aube-review-score')) return;
  class AubeReviewScore extends HTMLElement {
    connectedCallback() {
      if (!this.link) {
        this.link = document.createElement('a');
        this.link.className = 'ars-link';
        // The destination is local and intentionally fixed to the review section.
        this.link.href = '#avis';
        this.link.innerHTML = '<span class="ars-stars" aria-hidden="true">★★★★★<span>★★★★★</span></span><span class="ars-number"></span><span class="ars-count"></span><span class="ars-demo">Avis</span>';
        this.replaceChildren(this.link);
        this.onSummary = event => this.update(event.detail);
      }
      document.addEventListener('aube:reviews-summary', this.onSummary);
      document.querySelectorAll('aube-reviews').forEach(widget => {
        if (widget.reviewSummary) this.update(widget.reviewSummary);
      });
    }
    disconnectedCallback() {
      document.removeEventListener('aube:reviews-summary', this.onSummary);
    }
    update(data) {
      if (!data || data.product !== this.dataset.product) return;
      const count = Number(data.summary?.count);
      const average = Number(data.summary?.average);
      if (!Number.isInteger(count) || count < 1 || !Number.isFinite(average) || average < 1 || average > 5 || typeof data.isDemo !== 'boolean') {
        this.hidden = true;
        return;
      }
      const score = average.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
      const total = count.toLocaleString('fr-FR');
      this.querySelector('.ars-number').textContent = `${score}/5`;
      this.querySelector('.ars-count').textContent = `· ${total} avis`;
      this.querySelector('.ars-stars').style.setProperty('--ars-fill', `${average / 5 * 100}%`);
      this.querySelector('.ars-demo').hidden = !data.isDemo;
      this.link.setAttribute('aria-label', `Voir les ${total} ${data.isDemo ? 'faux avis' : 'avis'} : moyenne ${score} sur 5`);
      this.hidden = false;
    }
  }
  customElements.define('aube-review-score', AubeReviewScore);
})();
